import {useStaticQuery, graphql} from 'gatsby';

export const useCategories = () => {
  const allMdx = useStaticQuery(graphql`
    query Categories {
      categories: allMdx(
        filter: {
          frontmatter: {active: {ne: false}}
          fileAbsolutePath: {regex: "/(/categories/)/"}
        }
        sort: {fields: frontmatter___order, order: ASC}
      ) {
        edges {
          node {
            productsCategorie {
              ...ProductList
            }
            fields {
              slug
              relativePath
            }
            frontmatter {
              title
              description
              icon {
                publicURL
              }
            }
          }
        }
      }
    }
  `);
  return allMdx;
};

export default useCategories;
